import { render, staticRenderFns } from "./BaseLoaderDualRing.vue?vue&type=template&id=faff96ba&scoped=true"
var script = {}
import style0 from "./BaseLoaderDualRing.vue?vue&type=style&index=0&id=faff96ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faff96ba",
  null
  
)

export default component.exports